// Shared height cap for <SelectContent> dropdowns in the recipe module.
//
// The project default Radix position is `item-aligned`, which overlays the
// trigger and sets an INLINE height style that ignores any Tailwind max-height
// class — so long option lists (e.g. brands) balloon to fill the viewport.
// Pair this constant with `position="popper"` on the SelectContent: popper
// anchors the menu below the trigger and honors the class, and this caps it to
// ~18rem so it scrolls instead of running off-screen.
//
//   <SelectContent position="popper" className={SELECT_CONTENT_MAX_H}>
export const SELECT_CONTENT_MAX_H = "max-h-72";
